import { connect } from 'react-redux';
import LineGroup from '../components/LineGroup';
import { createLine } from '../actions/line';
import { addLineToLineGroup } from '../actions/linegroups';

// function findAltIds(state, lineId) {
//   // Flatten out groups
//   const grps = [
//     ...state.song.linegroups.allIds
//       .map(id => state.song.linegroups.byId[id])
//       .filter(grp => grp.lines.indexOf(lineId)),
//   ];
//   const grps = [...state.song.linegroups.allIds.map(id => grp.indexOf(lineId) >= 0)];

//   // Make sure lineId is part of the items
//   if (ids.indexOf(lineId) === -1) {
//     ids.push(lineId);
//   }

//   return ids;
// }

// function groupLines(state, lineIds) {
//   return lineIds
//     .map(altId => ({ line: state.song.lines.byId[altId], id: altId }))
//     .filter(x => x.line);
// }

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  linegroup: ownProps.linegroup,
  lines: ownProps.linegroup ? ownProps.linegroup.lines.map(id => state.song.lines.byId[id]) : [],
  line: ownProps.line,
  // id: ownProps.id,
  // alt: groupLines(state, findAltIds(state, ownProps.line.id)),
  // alt: findAltIds(state, ownProps.line.id).map(altId => state.song.lines.byId[altId]),
  // allLines: state.song.allLines,
  ui: state.ui,
  // onReplace: ownProps.onReplace,
  // selected: (state.ui.selectedItems.line || []).indexOf(ownProps.line.id) >= 0,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // onSelect: () => dispatch(selectItem('line', ownProps.line.id)),
  // onToggleSelect: () => dispatch(toggleSelectedItem('line', ownProps.line.id)),
  // onSelectRemove: () => dispatch(removeFromSelectedItems('line', ownProps.line.id)),
  onCreate: () => {
    const newLine = dispatch(createLine({}));
    return dispatch(addLineToLineGroup(ownProps.linegroup.id, newLine.obj.id));
  },
  onSelect: (altLineId) => {
    ownProps.onSelectAlt(altLineId);
  },
});

const LineGroupContainer = connect(mapStateToProps, mapDispatchToProps)(LineGroup);

export default LineGroupContainer;



// WEBPACK FOOTER //
// ./src/containers/LineGroupContainer.js